import { QueryClient, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import JobReport, { JobReportUpdateRequest } from "../models/JobReport";
import { QueryOpts } from "./api-hooks";
import { ApiError } from "../models/ApiResponse";
import { apiStore } from "../stores/api.store";
import { toast } from "../utils/toast";

export const queryClient = new QueryClient();

type JobReportExpand = "consultant" | "job.customer";

export type GetJobReportsParams = {
	expand?: JobReportExpand[];
	pool?: string;
};

export function useJobReports(query: GetJobReportsParams, opts: QueryOpts = {}) {
	return useQuery(
		["job-reports", query],
		() =>
			apiStore
				.get<{ jobReports: JobReport[]; totalCount: number }>({
					path: "/job-report",
					isAuthRequired: true,
					query: {
						expand: query.expand?.join(","),
						pool: query.pool,
					},
				})
				.then((d) => d.data),
		{
			...opts,
		}
	);
}

export function useJobReport(id: string, opts: QueryOpts = {}) {
	return useQuery(
		["job-reports", id],
		() =>
			apiStore
				.get<JobReport>({
					path: `/job-report/${id}`,
					isAuthRequired: true,
					query: {
						expand: "consultant,job.customer",
					},
				})
				.then((d) => d.data),
		{
			...opts,
		}
	);
}

export function useUpdateJobReport() {
	const queryClient = useQueryClient();

	return useMutation<any, ApiError, Pick<JobReport, "id"> & JobReportUpdateRequest>(
		({ id, ...body }) => {
			return apiStore
				.put({
					path: `/job-report/${id}`,
					isAuthRequired: true,
					body,
				})
				.then((d) => d.data)
				.catch((err) => {
					throw err;
				});
		},
		{
			onSuccess: () => {
				toast.successGeneric();
				queryClient.invalidateQueries(["job-reports"]);
			},
			onError: (err) => {
				toast.errorGeneric();
			},
		}
	);
}
